import {
  mdiAccountGroupOutline,
  mdiChartLineVariant,
  mdiCogOutline,
  mdiCommentTextMultipleOutline,
  mdiCommentTextOutline,
  mdiCompareHorizontal,
  mdiForumOutline,
  mdiRss,
  mdiShapeOutline,
  mdiShieldCrownOutline,
  mdiSwordCross,
  mdiTagOutline,
  mdiViewDashboardOutline,
} from "@mdi/js";

export default [
  {
    to: "/",
    icon: mdiViewDashboardOutline,
    label: "Dashboard",
  },
  {
    to: "/reviews",
    label: "Reviews",
    icon: mdiCommentTextOutline,
    // Live count of reviews needing a response; injected in LayoutAuthenticated.vue.
    dynamicBadge: "priorityInbox",
  },
  {
    to: "/branches",
    label: "Branches",
    icon: mdiCompareHorizontal,
    requiresBranches: true,
  },
  {
    to: "/topics",
    label: "Topics",
    icon: mdiTagOutline,
  },
  {
    to: "/entities",
    label: "Entities",
    icon: mdiShapeOutline,
  },
  {
    to: "/competitors",
    label: "Competitors",
    icon: mdiSwordCross,
  },
  {
    to: "/socials",
    label: "Social Buzz",
    icon: mdiRss,
  },
  {
    to: "/social-topics",
    superuser: true,
    label: "Social Topics",
    icon: mdiCommentTextMultipleOutline,
  },
  {
    to: "/social-entities",
    superuser: true,
    label: "Social Entities",
    icon: mdiShapeOutline,
  },
  {
    to: "/social-inbox",
    superuser: true,
    label: "Social Inbox",
    icon: mdiForumOutline,
  },
  {
    to: "/analytics",
    icon: mdiChartLineVariant,
    label: "Analytics",
  },
  {
    label: "Configuration",
    icon: mdiCogOutline,
    hideWhenReadOnly: true,
    menu: [
      {
        to: "/configuration/channels",
        label: "Channels",
      },
      {
        to: "/configuration/locations",
        label: "Locations",
      },
      {
        to: "/team",
        label: "Team",
      },
    ],
  },
  {
    to: "/backend/admin",
    label: "Admin",
    icon: mdiShieldCrownOutline,
    superuser: true,
  },
];
